/**
 * Created by xinjundong on 2017/11/20.
 * 检查页面滑动方向: 向上滑 还是 向下滑
 */
import { getRandomStr } from './funcs'
window.__CheckEvent__ = {}
window.__CheckManager__ = {}

export default class {
  constructor (downCallback, upCallback) {
    this.downCallback = downCallback
    this.upCallback = upCallback
    this.prePos = 0
    this.newPos = 0
    this.dir = null
    this.preDir = null
    this.init()
  }
  init () {
    let k = this;
    k.addEvent('touchstart', function (e) {
      k.dir = null
      if (k.dir) {
        k.preDir = k.dir
      }
      k.prePos = e.changedTouches[0].pageY
    })
    k.addEvent('touchmove', function (e) {
      k.newPos = e.changedTouches[0].pageY
      let len = Math.abs(k.newPos - k.prePos)
      if (len >= 10) {
        if (k.newPos <= k.prePos) {
          k.dir = 'down'
        } else {
          k.dir = 'up'
        }
      } else {
        k.dir = null
      }
    })
    k.addEvent('touchend', function (e) {
      if (k.dir === k.preDir) {
        return
      }
      k.set(k.dir)
    })
    k.addEvent('touchcancel', function (e) {
      if (k.dir === k.preDir) {
        return
      }
      k.set(k.dir)
    })
  }
  set (dir) {
    let k = this
    switch (dir) {
      case 'down':
        k.downCallback()
        break
      case 'up' :
        k.upCallback()
    }
  }
  addEvent (type, func) {
    let key = getRandomStr(type)
    window.__CheckEvent__[key] = func
    if (!window.__CheckManager__[type]) {
      window.__CheckManager__[type] = []
    }
    window.__CheckManager__[type].push(window.__CheckEvent__[key])
    document.addEventListener(type, window.__CheckEvent__[key])
  }
  removeEvents () {
    for (let type in window.__CheckManager__) {
      let tempArr = window.__CheckManager__[type]
      for (let func of tempArr) {
        document.removeEventListener(type, func)
        func = null
      }
      window.__CheckManager__[type] = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/utils/checkDir.js